import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { MunicipalityManagementComponent } from '../municipality-management.component';
import { MunicipalityManagementService } from '../services/municipality-management.service';
import { MunicipalityManagementConfigurationStore } from '../services/municipality-management-configuration.store';
import { MunicipalityManagementQueueStateService } from '../services/municipality-management-queue-state.service';

@Injectable({
  providedIn: 'root',
})
export class MunicipalityManagementNavigationGuard implements CanDeactivate<MunicipalityManagementComponent> {
  constructor(
    private _configStore: MunicipalityManagementConfigurationStore,
    private _service: MunicipalityManagementService,
    private _municipalityManagementQueueStateService: MunicipalityManagementQueueStateService
  ) {}

  canDeactivate(
    _component: MunicipalityManagementComponent,
    _currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    if (
      (!this._configStore.canNavigate || this._municipalityManagementQueueStateService.hasQueue()) &&
      currentState.url.localeCompare(nextState?.url ?? '') !== 0
    ) {
      return this._service.saveChanges(true).pipe(map((s) => s as boolean));
    }

    return true;
  }
}
